import { useState } from "react";
import { Badge } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";

const Step1CustomerSelection = ({ selectedCustomer, onSelectCustomer }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const mockData = [
    {
      id: "10844",
      name: "SparkMinds Technology Pte Ltd",
      type: "Organization",
      email: "checkpast12month@yopmail.com",
      phone: "+84 765161894",
      idCard: "S1234567A013",
      availableBalance: "111,604.9 SGD\n0 USD",
      pendingBalance: "0 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n18:23:59",
    },
    {
      id: "10843",
      name: "Thuy Nga Phan",
      type: "Individual",
      email: "checkpast12month@yopmail.com",
      phone: "+84 789908092",
      idCard: "check12month",
      availableBalance: "969 SGD\n0 USD",
      pendingBalance: "7,031.05 SGD\n11 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n11:38:29",
    },
    {
      id: "10842",
      name: "idjaoida",
      type: "Organization",
      email: "judhuiajhdoa@yopmail.com",
      phone: "+65 93213213",
      idCard: "154651651",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "05/03/2026\n10:41:31",
    },
    {
      id: "10841",
      name: "mani",
      type: "Organization",
      email: "manicure@yopmail.com",
      phone: "+65 96533256",
      idCard: "mniii889",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n16:42:24",
    },
    {
      id: "10840",
      name: "dynamite org",
      type: "Organization",
      email: "dynamite@yopmail.com",
      phone: "+65 12345678933",
      idCard: "123123113",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n15:03:44",
    },
    {
      id: "10839",
      name: "dinh phong check entity",
      type: "Organization",
      email: "dinhphong01@yopmail.com",
      phone: "+65 12223456789",
      idCard: "dddd",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n14:45:34",
    },
    {
      id: "10838",
      name: "asdad",
      type: "Organization",
      email: "asdasd@sadasd.qq",
      phone: "+65 33124214",
      idCard: "1241",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n14:44:11",
    },
  ];

  const columns = [
    {
      label: "User ID",
      key: "id",
      className: "ps-4",
    },
    {
      label: "Name",
      key: "name",
      className: "ps-4",
      render: (item) => (
        <span className="fw-medium text-black">{item.name}</span>
      ),
    },
    {
      label: "Type",
      key: "type",
      className: "ps-4",
      render: (item) => (
        <Badge
          className="fw-bold px-2 py-1"
          bg={item.type === "Organization" ? "dark" : "light"}
          style={{
            color: item.type === "Organization" ? "#fff" : "#475467",
            borderRadius: "20px",
            backgroundColor:
              item.type !== "Organization" ? "#F2F4F7" : undefined,
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    {
      label: "Email",
      key: "email",
      className: "ps-4",
    },
    {
      label: "Phone Number",
      key: "phone",
      className: "ps-4",
    },
    {
      label: "ID Card Number",
      key: "idCard",
      className: "ps-4",
    },
    {
      label: "Available balance",
      key: "availableBalance",
      className: "ps-4",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-black text-end pe-4 fw-medium",
    },
    {
      label: "Pending balance",
      key: "pendingBalance",
      className: "ps-4",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-black text-end pe-4 fw-medium",
    },
    {
      label: "Status",
      key: "status",
      className: "ps-4",
      render: (item) => (
        <span
          className="px-2 rounded-2 bg-body py-1 fw-bold d-inline-block"
          style={{
            fontSize: "11px",
          }}
        >
          {item.status}
        </span>
      ),
    },
    {
      label: "KYC Status",
      key: "kycStatus",
      className: "ps-4",
      render: (item) => (
        <span
          className="px-3 py-1 rounded-2 bg-light fw-bold d-inline-block"
          style={{
            fontSize: "11px",
          }}
        >
          {item.kycStatus}
        </span>
      ),
    },
    {
      label: "Created Time",
      key: "createdTime",
      className: "ps-4",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-muted fs-12",
    },
  ];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mockData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="d-flex align-items-end mb-4 gap-2">
        <div style={{ width: "200px" }}>
          <CommonInput label={"Name"} placeholder="Enter name" />
        </div>
        <div style={{ width: "200px" }}>
          <CommonInput label={"ID card no"} placeholder="Enter ID Card No" />
        </div>
        <div style={{ width: "200px" }}>
          <CommonInput label="Phone number" placeholder="Enter phone" />
        </div>
        <div style={{ width: "200px" }}>
          <CommonInput label={"Email"} placeholder="Enter email" />
        </div>
        <CommonButton
          variant="outline"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
          className="p-0 d-flex align-items-center justify-content-center"
        >
          <i className="flaticon-381-repeat-1 fs-18"></i>
        </CommonButton>
        <CommonButton
          className="p-0 d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
        >
          <i className="flaticon-381-search-1 fs-18 text-white"></i>
        </CommonButton>
      </div>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={currentItems}
            totalItems={mockData.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={paginate}
            showPagination={true}
            rowClassName={(item) =>
              selectedCustomer && selectedCustomer.id === item.id
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => onSelectCustomer(item)}
          />
        </div>
      </div>
    </>
  );
};

export default Step1CustomerSelection;
